import { LocaleCommon } from '../en/common'

// includes new-match, notify, external, not-found
const common: LocaleCommon = {
  addMatches: '添加比賽',
  editMatch: '編輯比賽',
  deleteMatch: '删除比賽',
  oldPass: '舊密碼',
  newPass: '新密碼',
  confirmPass: '確認密碼',
  save: '保存',
  firstName: '名',
  lastName: '姓',
  location: '地點',
  yourBirthday: '您的生日',
  birthday: '生日',
  birthDateMin: `要為 13 歲以下的使用者建立帳戶，請填寫以下表格：`,
  under13AccountCreationForm: '帳戶建立申請表',
  gender: '性別',
  phone: '電話',
  yourPhone: '您的電話',
  congrats: '恭喜',
  error: '錯誤',
  search: '搜尋',
  filters: '過濾',
  apply: '申請',
  clearAll: '清空所有',
  distance: '距離',
  noLimit: '沒有限制',
  man: '男性',
  woman: '女性',
  anybody: '任何人',
  men: '男性',
  women: '女性',
  type: '類型',
  doubles: '雙打',
  singles: '單打',
  Doubles: '雙打',
  Singles: '單打',
  Any: '任何',
  duprRating: 'DUPR級別',
  ageRange: '年齡範圍',
  minAge: '最小年齡',
  maxAge: '最大年齡',
  under19: '19歲以下',
  share: '共亯',
  message: '訊息',
  messages: '留言',
  email: '電子郵箱',
  emailPlaceHolder: '輸入電子郵箱',
  confirmEmail: '確認電子郵箱',
  confirmEmailPlaceHolder: '輸入確認郵箱',
  password: '密碼',
  passwordPlaceHolder: '輸入密碼',
  confirmPassword: '確認密碼',
  confirmPasswordPlaceHolder: '輸入確認密碼',
  fullName: '全名',
  fullNamePlaceHolder: '輸入全名',
  birthDate: '生日日期',
  birthDatePlaceHolder: '選擇生日日期',
  phonePlaceHolder: '輸入電話號碼',
  continue: '繼續',
  selectCountry: '選擇一個國家',
  submit: '提交',
  forgotPassword: '忘記密碼',
  cancel: '取消',
  textDigitCode: '輸入4比特電子驗證碼',
  resend: '重新發送',
  verify: '驗證',
  noMoreResults: '沒有更多搜尋結果',
  contactSupport: '聯絡客服',
  viewAll: '查看全部',
  payments: '付款',
  setUpPayments: '設立支付方式',
  details: '詳情',
  navigate: '導航',
  member: '會員',
  members: '會員們',
  exportCSV: '匯出CSV',
  exportFailed: '無法匯出成員名單，請再試一次。',
  exportTimedOut: '匯出時間比預期久，請稍後再試。',
  exportConnectionLost: '準備匯出時連線中斷，請再試一次。',
  downloadCSVDesc: '下載我們的CSV範本，通過使用電子郵件管道創建批量邀請',
  downloadCSVNote: '注意：您需要删除CSV檔案的標題',
  learnMore: '瞭解更多資訊',
  downloadTemplate: '下載範本',
  dragFile: '將您的CSV檔案拖到此處或者',
  browseFile: '瀏覽檔案',
  removeFile: '刪除檔',
  matches: '一些比賽',
  match: '比賽',
  sort: '分類',
  newToOld: '從最新到最舊',
  oldToNew: '從最舊到最新',
  clearFilters: '清除設定',
  matchId: '比賽編號：',
  reUpload: '重新上傳',
  events: '活動',
  deleteEvent: '删除活動',
  deleteEventDesc: '删除此賽事活動也將删除與其關聯的隊伍，確認删除此賽事活動',
  confirm: '確認',
  delete: '删除',
  registeredPlayers: '已注册選手',
  upcoming: '即將到來',
  draft: '預選',
  open: '打開',
  ongoing: '進行中',
  completed: '已完成',
  logo: '標誌',
  eventLogo: '賽事標誌',
  eventName: '賽事名稱',
  registration_url: '註冊網址',
  summary: '總結',
  whatAreTheDetails: '有哪些細節？',
  entryFee: '報名費',
  entryFeeDesc: '選手將支付除了報名費以外，還有賽事單項費，您可以稍後設定每個單項的費用價格',
  memberPrice: '會員價',
  nonMemberPrice: '非會員價',
  policies: '政策',
  uploadWaiver: '上傳賽事聲明',
  uploadWaiverDesc: 'DUPR建議所有比賽都要有運動責任風險豁免書',
  liabilityWaiver: '責任豁免',
  refundPolicy: '退費政策',
  refundPolicyDesc:
    '如果已注册比賽的選手在聯賽開始前取消比賽，他們會得到全額或部分退款嗎？ 如果他們在聯賽開始後取消比賽，會得到部分退款嗎？',
  healthPolicy: '健康政策',
  healthPolicyDesc: '您的聯隊對參與者的健康和安全有具體的規定嗎？',
  bracket: '單個比賽項目',
  brackets: '一個以上比賽項目',
  addBracket: '添加比賽項目',
  select: '選擇',
  playerGroup: '賽事選手群',
  format: '形式',
  ratingRange: '級別範圍',
  minimum: '最小',
  maximum: '最大',
  name: '名稱',
  bracketName: '項目名稱',
  autoGenerate: '自動生成',
  courts: '比賽球場',
  courtsDesc: '球場數量（最少1個，最多8個）',
  maxTeams: '最多團隊數量',
  maxTeamsDec: '有多少支隊伍將參加這項比賽？',
  waitList: '候補名單',
  waitListDesc: '您希望允許多少個團隊加入候補名單？',
  registration: '注册',
  registrationDesc: '設定一個參賽選手可以注册的起始日期',
  startDateTime: '開始日期和時間',
  endDateTime: '結束日期和時間',
  competition: '競賽',
  competitionDesc: '設定此組別比賽的日期和時間',
  timeZone: '時區',
  price: '價格',
  priceDesc: '選手將支付這筆費用以及報名費',
  selectAnImage: '選擇要上傳的影像',
  loadingImage: '正在加載影像…',
  chooseFile: '選擇檔案',
  invite: '邀請',
  optional: '（可選）',
  messageAndDataRatesMayApply: '可能需要支付消息和數據費用。',
  sendInvite: '發送邀請',
  invites: '邀請',
  requests: '請求',
  invited: '已經邀請',
  ignoreAll: '全部忽略',
  acceptAll: '全部接受',
  ignore: '忽略',
  cancelInvite: '取消邀請',
  address: '地址',
  addNew: '添加新的',
  mi: '英哩',
  startsIn: '開始於',
  endsIn: '結束於',
  downloadLiabilityWaiver: '下載免責聲明',
  healthSafetyPolicy: '健康與安全政策',
  yes: '是',
  no: '否',
  addPartner: '添加搭檔',
  addPartnerNote: '您也可以等到注册後再添加搭檔',
  ok: '完成',
  success: '成功',
  failure: '失敗',
  signUpOrLogin: '注册或登入以查看此資訊',
  accept: '接受',
  goBack: '退回',
  with: '跟',
  game: '一局比賽',
  highToLowRating: '評級從高到低',
  lowToHighRating: '評級從低到高',
  add: '添加',
  confirmation: '確認',
  back: '返回',
  next: '下一步',
  saveChanges: ' Save Changes',
  sortingRules: '排序規則',
  sortingRulesDesc: '小組按平均級別分類，經認證的評級比臨時評級權重更大，顯示NR等級的選手默認是2.00級。',
  create: '創建',
  matchDate: '比賽日期',
  time: '時間',
  connectWith: '與…連接',
  externalLoginCheckbox: '在此頁面創建新會話，DUPR只允許使用只讀存取權限，我的所有數據都將得到安全的保護',
  logging: '登入…',
  login: '注册',
  saveMatch: '保存比賽',
  submitMatches: '提交賽事',
  confirmSubmitMatches: '這些比賽將被提交，選手評分將很快更新。',
  event: '比賽',
  eventPlaceHolder: '賽事名稱',
  date: '日期',
  checkboxAddYourSelf: '將自己添加為這場比賽的選手嗎？',
  team1: '第一組',
  team2: '第二組',
  searchPlayer: '蒐索選手',
  score: '比分',
  standard: '標準賽制（發球得分）',
  rally: '其他賽制（直接得分）',
  game1: '第一局',
  game2: '第二局',
  game3: '第三局',
  game4: '第四局',
  game5: '第五局',
  addAnotherMatch: '添加另一場比賽',
  oops: '糟糕！',
  redirectedDashboard: '您將被重返回到主頁面',
  seconds: '秒',
  DUPRIDCopied: 'DUPR帳戶號已複製',
  copyClipboard: '複製到剪貼板',
  myAccount: '我的帳戶',
  editProfile: '編輯個人主頁',
  passwordSecurity: '密碼和安全性',
  infoSupport: '資訊和支持',
  support: '支持',
  runEvents: '舉辦賽事',
  FAQs: '常見問題',
  termsUse: '使用條款',
  privacyPolicy: '隱私策略',
  logout: '註銷',
  warning: '警告',
  reset: '重置',
  Members: '會員們',
  Matches: '一些比賽',
  Events: '活動',
  Invites: '邀請',
  Queue: '列隊',
  Standings: '積分榜',
  Players: '選手',
  Teams: '隊伍',
  UnmatchedPlayer: '未參賽的球員',
  Payments: '付款',
  performance: '表現',
  myPerformance: '我的表現',
  newMatch: '新比賽',
  players: '選手',
  clubs: '俱樂部',
  Week: '星期',
  Month: '月',
  RoundRobin: '小組循環賽',
  Waterfall: '瀑布錦標賽',
  FlexLeague: '聯盟賽',
  Mixed: '混合',
  Open: '打開',
  Men: '男性',
  Women: '女性',
  ViewAll: '查看全部',
  Round: '巡迴的',
  Round1: '第一輪',
  Round2: '第二輪',
  Round3: '第三輪',
  Round4: '第四輪',
  Round5: '第五輪',
  Round6: '第六輪',
  Round7: '第七輪',
  Round8: '第八輪',
  Round9: '第九輪',
  Round10: '第十輪',
  Dashboard: '主頁面',
  SearchPlayer: '蒐索選手',
  SearchEvents: '搜尋活動',
  Rankings: '排行榜',
  Genie: '精靈',
  Shops: '商店',
  HowItWorks: '怎麼運作的',
  RunEvents: '舉辦賽事',
  CollegiatePickleball: '大學匹克球',
  News: '訊息',
  LogIn: '登入',
  SignUp: '注册',
  decline: '下降',
  savePublish: '儲存並發布',
  publish: '發布',
  publishing: '出版',
  upload: '上傳',
  signUpLogin: '註冊或登入',
  January: '一月',
  February: '二月',
  March: '三月',
  April: '四月',
  May: '五月',
  June: '六月',
  July: '七月',
  August: '八月',
  September: '九月',
  October: '十月',
  November: '十一月',
  December: '十二月',
  following: '下列的',
  followers: '追隨者',
  rating: '評分',
  MatchDate: '比賽日期',
  CreatedDate: '建立日期',
  ModifiedDate: '修改日期',
  follow: '跟隨',
  unFollow: '取消追蹤',
  noFollowing: '該玩家尚未關注任何人',
  home: '家',
  removeConfirm: '您確定要刪除它嗎？',
  edit: '編輯',
  play: '玩',
  invitePlayerSuccess: '邀請玩家成功',
  createAMatch: '建立匹配',
  marketingAssets: '行銷資產',
  settings: '設定',
  compliantText: '勾選此方塊即表示您同意接收有關我們的產品更新、活動、新聞和優惠的更多信息',
  communityGuidelines: '社區準則',
  minorLeaguePickleball: 'Minor League',
  collegiatePickleball: 'Collegiate',
  blog: '部落格',
  playerName: '參賽者姓名',
  addMembers: '新增群組成員',
  verifyEmail: '驗證您的電子郵件',
  mustVerify: '您必須驗證您的電子郵件才能存取此功能。',
  clickResendLink: '按一下「重新傳送連結」以接收驗證連結。',
  changeEmail: '您想更改您的電子郵件嗎？',
  alreadyVerified: '已驗證',
  resendLink: '重新發送連結',
  aLinkWasSent: '連結已發送到您的新電子郵件！',
  deleteMatchDesc:
    '您確定要刪除此符合項目嗎？一旦刪除，您將無法再次恢復該比賽，並且該比賽將從球員個人資料和俱樂部比賽頁面中刪除。',
  externalMatchManaged: '此比賽是在外部平台上上傳的，必須在該平台上進行編輯或刪除。',
  externalApplication: '世界上最準確的匹克球評級',
  venturedPath: '你已經冒險偏離了道路。',
  notFollowing: '該玩家尚未關注任何人',
  noFollower: '該玩家還沒有任何追蹤者',
  hasVerifiedMatch: '玩家已驗證比賽',
  matchOwner: '比賽擁有者',
  firstNamePlaceHolder: '輸入名字',
  lastNamePlaceHolder: '輸入姓氏',
  removed: '已刪除',
  today: '今天',
  yesterday: '昨天',
  privacy: '隱私',
  hideAge: '隱藏年齡',
  hideLocation: '隱藏位置',
  displayAge: '顯示年齡',
  displayLocation: '顯示位置',
  doNotTrack: '請勿追蹤',
  allowTracking: '允許追蹤',
  allowTargetedAds: '允許定向廣告',
  disallowTargetedAds: '不允許定向廣告',
  subscriptions: '訂閱',
  haveActiveSubscription: '您有一個有效的訂閱。',
  toManageSubscription: '請管理您的訂閱',
  visitThisLinkTo: '請訪問此鏈接以',
  subscriptionStatus: '訂閱狀態',
  manageSubscription: '管理訂閱',
  and: '和',
  phoneVerify:
    '輸入我的手機號碼即表示我同意接收用於帳戶驗證和雙重認證（2FA）的簡訊。標準訊息和數據費率可能適用。這些訊息僅用於保護我的帳戶和驗證我的身份，不用於行銷目的',
  phoneOptInRequired: '您必須同意上述的簡訊選擇加入條款，以進行帳戶驗證和雙重認證。',

  verifyYourPhone: '驗證您的手機',
  sentCodeTo: '我們已向 {{phone}} 發送了驗證碼',
  sendCodeTo: '向 {{phone}} 發送驗證碼',
  phoneVerified: '電話號碼已驗證',
  youreAllSet: '一切就緒。',
  sending: '發送中…',
  sendCode: '發送驗證碼',
  verifying: '驗證中…',
  resendIn: '在 {{s}} 秒後重新發送',
  resendCode: '重新發送驗證碼',
  otpDisclaimer: '可能會產生標準短信和數據費率。',
  invalidCode: '驗證碼無效，請重試。',
  genericError: '發生錯誤，請重試。',
  phoneMissing: '無可驗證的電話號碼。',
  verifyingNumber: '正在驗證號碼',
  iso: 'ISO',
  changeNumber: '更改號碼',
}

export default common
